import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultMemoize } from 'reselect';
import _forEach from 'lodash/forEach';
import _findIndex from 'lodash/findIndex';
import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import cx from 'classnames';
export var getUpdatedFields = defaultMemoize(function () {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var sections = arguments.length > 1 ? arguments[1] : undefined;
  var updatedFields = _objectSpread({}, fields);
  var skipList = [];
  var classList = [];
  _forEach(sections, function () {
    var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
    _forEach(section.fieldIds, function (field) {
      updatedFields[field] = updatedFields[field] || {};
      var renderOptions = updatedFields[field].renderOptions || EMPTY_OBJECT;
      var className = field;
      updatedFields[field].renderOptions = _objectSpread(_objectSpread({}, renderOptions), {}, {
        className: cx(field.className, "full-width formFocusable ".concat(className), "".concat(renderOptions.className))
      });
      classList.push(className);
      var handleKeyBoardOnChange = _get(fields, "".concat(field, ".renderOptions.handleKeyBoardOnChange"), false);
      if (handleKeyBoardOnChange) {
        skipList.push(className);
      }
    });
  });
  return {
    fields: updatedFields,
    skipList: skipList,
    classList: classList
  };
});
export var findParent = function findParent(element, className) {
  var elemClassName = element && element.getAttribute !== undefined && element.getAttribute('class');
  if (elemClassName && elemClassName.includes(className)) {
    return element;
  }
  return element.parentNode && findParent(element.parentNode, className);
};
export var getIndexByClassName = function getIndexByClassName(classList, className) {
  var elementClassList = className.split(' ');
  return _findIndex(classList, function (current) {
    return elementClassList.includes(current);
  });
};